import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/trophy-icon.png'
import _imports_1 from '../../assets/icons/gift-icon.png'
import _imports_2 from '../../assets/icons/red-packet-icon1.png'
import _imports_3 from '../../assets/icons/time-icon.png'
import _imports_4 from '@/assets/images/drive-tag.png'
import _imports_5 from '@/assets/images/discount-tag.png'
import _imports_6 from '@/assets/images/default-discount-tag.png'


const _withScopeId = n => (_pushScopeId("data-v-ce6f4f2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "series-discount-list-wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "result-tip"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前无符合条件的车系", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "为您推荐以下车系", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "result-tip"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前无符合条件的车系", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请选择其他品牌或附近城市", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "series-discount-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "sg-photo" }
const _hoisted_14 = { alt: "" }
const _hoisted_15 = { class: "sg-name" }
const _hoisted_16 = { class: "m-con" }
const _hoisted_17 = { class: "m-con-top" }
const _hoisted_18 = {
  key: 0,
  class: "m-item"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "m-text" }
const _hoisted_21 = {
  key: 1,
  class: "m-item"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "m-text" }
const _hoisted_24 = { class: "m-item min-price last" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "official bold" }, "指导价", -1))
const _hoisted_26 = { class: "min-price" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万元起", -1))
const _hoisted_28 = { class: "m-item gift-price" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "m-item replace-discount" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 0,
  class: "m-item news-end-time last"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_38 = { class: "min-price" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "优惠价", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万元起", -1))
const _hoisted_41 = {
  key: 0,
  class: "purchase-wrap"
}
const _hoisted_42 = { class: "purchase-price left-purchase" }
const _hoisted_43 = {
  key: 0,
  class: "price-txt"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "168", -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode("元 ")
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "price-txt"
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode("万元 ")
const _hoisted_49 = { class: "purchase-price right-purchase" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "购置税减免", -1))
const _hoisted_51 = { class: "price-txt" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("万元")
const _hoisted_53 = {
  key: 0,
  class: "drive-tag"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 1,
  class: "discount-tag"
}
const _hoisted_57 = {
  key: 0,
  src: _imports_5,
  alt: ""
}
const _hoisted_58 = {
  key: 1,
  src: _imports_6,
  alt: ""
}
const _hoisted_59 = { class: "max-discount" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "txt",
  style: { color: '#656565' }
}, "加载中...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_btn = _resolveComponent("custom-btn")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_coupon_popup = _resolveComponent("coupon-popup")!
  const _component_enroll_success_popup = _resolveComponent("enroll-success-popup")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.noResult === 1 && _ctx.recommendNoResult === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_ctx.noResult === 1 && _ctx.recommendNoResult === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
          : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("ul", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            ref_for: true,
            ref: "itemRef",
            class: _normalizeClass(['item', { 'last-item': _ctx.list.length == index + 1 },{'purchase-item': item.lessPurchaseTax}]),
            key: index
          }, [
            _createElementVNode("div", {
              class: "l-con",
              onClick: ($event: any) => (_ctx.jumpToSerialPage(item))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
                  [_directive_lazy, item.sgPhotoSrc]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.serialGroupName), 1)
            ], 8, _hoisted_12),
            _createElementVNode("div", _hoisted_16, [
              (item.type === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_17, [
                      (item.saleRank)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(item.saleRank), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.rank)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(item.rank), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, [
                        (_ctx.getOfficialPrice(item.officialPrice) !== '暂无报价')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", {
                                class: "official-price bold",
                                style: _normalizeStyle({ color: _ctx.activityInfo.subjectRgb })
                              }, _toDisplayString(_ctx.getOfficialPrice(item.officialPrice)), 5),
                              _hoisted_27
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "official-price-none bold",
                              style: _normalizeStyle({ color: _ctx.activityInfo.subjectRgb })
                            }, _toDisplayString(_ctx.getOfficialPrice(item.officialPrice)), 5))
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      (item.giftPrice)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, "赠" + _toDisplayString(item.giftPrice) + "元礼包", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_31, "分期购车超划算"))
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      (item.replaceDiscount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "享" + _toDisplayString(item.replaceDiscount) + "万元置换补贴", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_35, "赠汽配大礼包"))
                    ]),
                    (item.newsEndTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("span", null, _toDisplayString(item.newsEndTime), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("span", {
                        class: "price bold",
                        style: _normalizeStyle({ color: _ctx.activityInfo.subjectRgb })
                      }, _toDisplayString(item.minPrice), 5),
                      _hoisted_40
                    ])
                  ], 64))
            ]),
            _createElementVNode("div", {
              class: "r-con",
              style: _normalizeStyle(item.type === 1 ? '' : 'margin-top: -10px;')
            }, [
              (item.lessPurchaseTax)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("p", null, _toDisplayString(item.type === 1 ? '到店领最高' : '经销商优惠'), 1),
                      (item.type === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
                        : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createElementVNode("span", null, _toDisplayString(item.maxDiscount), 1),
                            _hoisted_48
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", null, _toDisplayString(item.deductionAmount), 1),
                        _hoisted_52
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (item.type === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                      : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          (item.maxDiscount)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                            : (_openBlock(), _createElementBlock("img", _hoisted_58)),
                          _createElementVNode("div", _hoisted_59, _toDisplayString(item.maxDiscount), 1)
                        ]))
                  ], 64)),
              _createVNode(_component_custom_btn, {
                class: "sign-up-btn",
                size: 'middle',
                bgColor: _ctx.activityInfo.subjectRgb,
                onClick: ($event: any) => (_ctx.toggleEnrollPopup(true, item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.type === 1 ? '预约试驾' : '领取优惠'), 1)
                ]),
                _: 2
              }, 1032, ["bgColor", "onClick"])
            ], 4)
          ], 2))
        }), 128))
      ], 512), [
        [_vShow, 
          (_ctx.noResult === 0 && _ctx.recommendNoResult === 1) ||
          (_ctx.noResult === 0 && _ctx.recommendNoResult === 0) ||
          (_ctx.noResult === 1 && _ctx.recommendNoResult === 0)
        ]
      ])
    ]),
    _withDirectives(_createVNode(_component_van_loading, {
      class: "loading-box",
      type: "spinner",
      size: "50px",
      vertical: "",
      color: _ctx.activityInfo.subjectRgb
    }, {
      default: _withCtx(() => [
        _hoisted_60
      ]),
      _: 1
    }, 8, ["color"]), [
      [_vShow, _ctx.isShowLoading]
    ]),
    _createVNode(_component_coupon_popup, {
      enrollSgInfo: _ctx.enrollSgInfo,
      isShowPopup: _ctx.isShowPopup,
      onToggleEnrollPopup: _ctx.toggleEnrollPopup,
      onEnrollSuccess: _ctx.enrollSuccess
    }, null, 8, ["enrollSgInfo", "isShowPopup", "onToggleEnrollPopup", "onEnrollSuccess"]),
    _createVNode(_component_enroll_success_popup, {
      isShowPopup: _ctx.isShowSuccessPopup,
      popupType: _ctx.successPopupType,
      onToggleEnrollSuccessPopup: _ctx.toggleEnrollSuccessPopup
    }, null, 8, ["isShowPopup", "popupType", "onToggleEnrollSuccessPopup"])
  ]))
}